import FeedbackError from '../../../components/atoms/feedbacks/feedback-error.vue'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline.vue'

export default {
  components: { FeedbackError, PageHeadline },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      isFocusCurrentPassword: false,
      isFocusNewPassword: false,
      isFocusNewPasswordConfirmation: false,
      isCurrentPasswordEyeOpen: false,
      isNewPasswordEyeOpen: false,
      isNewPasswordConfirmationEyeOpen: false,
      showableFeedback: false,
      message: ''
    }
  },
  mounted() {
    const showableErrorFeedback = document.querySelector('.box-list--alert')
    console.log(showableErrorFeedback)

    if (showableErrorFeedback) {
      this.showFeedback('変更できませんでした')
    }
  },
  computed: {
    isNotEmptyCurrentPassword() {
      return this.currentPassword.length !== 0
    },
    isCurrentPasswordActive() {
      return (
        this.isNotEmptyCurrentPassword ||
        this.isFocusCurrentPassword ||
        this.isCurrentPasswordEyeOpen
      )
    },
    isNotEmptyNewPassword() {
      return this.newPassword.length !== 0
    },
    isNewPasswordActive() {
      return (
        this.isNotEmptyNewPassword ||
        this.isFocusNewPassword ||
        this.isNewPasswordEyeOpen
      )
    },
    isNotEmptyNewPasswordConfirmation() {
      return this.newPasswordConfirmation.length !== 0
    },
    isNewPasswordConfirmationActive() {
      return (
        this.isNotEmptyNewPasswordConfirmation ||
        this.isFocusNewPasswordConfirmation ||
        this.isNewPasswordConfirmationEyeOpen
      )
    },
    isSubmittable() {
      return (
        this.isNotEmptyCurrentPassword &&
        this.isNotEmptyNewPassword &&
        this.isNewPasswordConfirmationActive
      )
    }
  },
  methods: {
    onCurrentPasswordFocus() {
      this.isFocusCurrentPassword = true
    },
    onCurrentPasswordBlur() {
      this.isFocusCurrentPassword = false
    },
    toggleCurrentPasswordEye() {
      this.isCurrentPasswordEyeOpen = !this.isCurrentPasswordEyeOpen
    },
    onNewPasswordFocus() {
      this.isFocusNewPassword = true
    },
    onNewPasswordBlur() {
      this.isFocusNewPassword = false
    },
    toggleNewPasswordEye() {
      this.isNewPasswordEyeOpen = !this.isNewPasswordEyeOpen
    },
    onNewPasswordConfirmationFocus() {
      this.isFocusNewPasswordConfirmation = true
    },
    onNewPasswordConfirmationBlur() {
      this.isFocusNewPasswordConfirmation = false
    },
    toggleNewPasswordConfirmationEye() {
      this.isNewPasswordConfirmationEyeOpen = !this
        .isNewPasswordConfirmationEyeOpen
    },
    enterFeedback() {
      setTimeout(() => {
        this.showableFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableFeedback = true
      this.message = message
    }
  }
}
